import { render, staticRenderFns } from "./DSGearIcon.vue?vue&type=template&id=559b0b04&scoped=true&"
import script from "./DSGearIcon.vue?vue&type=script&lang=js&"
export * from "./DSGearIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559b0b04",
  null
  
)

export default component.exports